module.exports = __webpack_public_path__ + "img/chevron-right-solid-lightblue.2a36eb58.svg";